import {createMultiStyleConfigHelpers} from '@chakra-ui/system';

import {tokens as dark} from '../../../generated/dark';
import {tokens as light} from '../../../generated/light';
import {labelTheme} from '../../Label/theme';
import {textTheme} from '../../Text/theme';

import {listAnatomy} from './anatomy';

const numberBadgeTokens = {
  light: light.components[`number-badge`].default,
  dark: dark.components[`number-badge`].default,
};

const {defineMultiStyleConfig} = createMultiStyleConfigHelpers(listAnatomy.keys());

export const widgetListTheme = defineMultiStyleConfig({
  baseStyle: () => ({
    container: {
      listStyleType: `none`,
      flex: 1,
      display: `flex`,
      flexDirection: `column`,
      flexBasis: 0,
      gap: `space-150`,
      alignSelf: `flex-start`,
      overflow: `hidden`,
      justifyContent: `flex-start`,
      /* Aligns items at the start of the container */
      alignItems: `flex-start`,
      [`&[data-vertical]`]: {
        flexDirection: `row`,
        flexWrap: `wrap`,
      },
    },
    'item-container': {
      display: `flex`,
      alignItems: `center`,
      alignContent: `center`,
      maxW: `100%`,
      alignSelf: `stretch`,
      minWidth: 0 /* Allows the text to shrink to fit content */,

      // alignSelf: `stretch`,
      padding: `space-050`,
      gap: `space-150`,
      flexWrap: `nowrap`,
      borderRadius: `radius-100`,
      _hover: {
        textDecoration: `none`,
      },
      [`&[data-interactive]`]: {
        _hover: {
          cursor: `pointer`,
          bgColor: `purple-sea.100`,
          _dark: {
            bgColor: `purple-sea.800`,
          },
        },
      },
    },
    'item-content': {
      display: `flex`,
      maxW: `100%`,
      alignItems: `center`,
      flexWrap: `nowrap`,
      overflow: `hidden`,
    },
    bullet: {
      width: `space-300`,
      height: `space-300`,
      padding: `space-050`,
      display: `flex`,
      alignItems: `center`,
      justifyContent: `center`,
    },
    label: {
      overflow: `hidden`,
      whiteSpace: `nowrap`,
      textOverflow: `ellipsis`,
      ...textTheme.baseStyle?.(),
      ...textTheme.sizes?.md,
      color: `text.secondary`,
    },
    value: {
      ...labelTheme.baseStyle?.(),
      ...labelTheme.sizes?.md,
      fontWeight: `600`,
      textAlign: `right`,
      whiteSpace: `nowrap`,
      fontSize: `md`,
      display: `flex`,
      alignItems: `center`,
      justifyContent: `center`,
      px: `space-050`,
      color: numberBadgeTokens.light[`text-default`],
      _dark: {
        color: numberBadgeTokens.dark[`text-default`],
      },
    },
    percentage: {
      ...textTheme.baseStyle?.(),
      ...textTheme.sizes?.md,
      color: `text.tertiary`,
      ...textTheme.sizes?.md,
    },
  }),
  variants: {
    packed: {
      label: {
        flexGrow: 1,
      },
      value: {
        flexGrow: 1,
      },
    },
    spaced: {
      'item-content': {
        alignSelf: `stretch`,
        flexGrow: 1,
      },
      label: {
        flexGrow: 1,
      },
    },
  },
  defaultProps: {
    variant: `packed`,
  },
});
